import { useEffect, useRef, useState } from 'react'
import ReactPlayer from 'react-player'
import {
  animeListImages,
  articelsHomePageImages,
  postListNewImages,
  topAnimesImages,
  userProfileImages,
} from '../../services/images.service'
import { TelegramShareButton, WhatsappShareButton } from 'react-share'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import { getAnimeDetailsUrl, getAnimeImage } from '../../services/util.service'
import {
  daysTranslation,
  mapAndTranslate,
  translationMap,
  translatedSeason,
  translatedStatus,
  extractMinutes,
} from '../../data/translationMap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAnimesByIds } from '../../store/slices/animeDB.slice'
import { GreyBorderBottom } from '../ui/elements'
import { DiscordIcon, TelegramIcon, TiktokIcon, WhatsappIcon } from '../ui/icons/shared'

export function AnimeInfoMobile({ anime }) {
  const [isPlaying, setIsPlaying] = useState(false)
  const [openSection, setOpenSection] = useState(null)
  const [moreInfo, setMoreInfo] = useState(null)
  const [expandedAnime, setExpandedAnime] = useState(null)
  const [openSynopsis, toggleSynopsis] = useState(false)
  const [openBackground, toggleBackground] = useState(false)

  const dispatch = useDispatch()
  const { relationsData } = useSelector((state) => state.animeDB) // שמירת המידע ב־redux

  useEffect(() => {
    if (!anime || !anime.relations) return

    const relationIds = anime.relations.flatMap((rel) =>
      rel.entry.map((entry) => entry.mal_id)
    )

    if (relationIds.length) {
      dispatch(fetchAnimesByIds(relationIds))
    }
  }, [anime, dispatch])

  const sliderRef = useRef(null)

  const slidesToShowCount = Math.min(
    4,
    anime.relations?.length || anime.similarAnime?.length || 1
  ) // מוודא שלא יהיה כפול

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: slidesToShowCount > 1, // השבתת אינסוף אם יש רק פריט 1
    autoplay: slidesToShowCount > 1, // הפעלת אוטומטי רק אם יש יותר מאחד
    autoplaySpeed: 5000,
    cssEase: 'linear',
    pauseOnHover: true,
    pauseOnFocus: true,
    speed: 600,
    slidesToShow: slidesToShowCount, // הגבלת כמות השקופיות בהתאם לכמות האובייקטים
    slidesToScroll: 1,
  }

  const toggleExpand = (animeId) => {
    setExpandedAnime((prev) => (prev === animeId ? null : animeId))
  }

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section)
  }
  const toggleMoreInfo = (section) => {
    setMoreInfo(moreInfo === section ? null : section)
  }

  return (
    <div>
      <nav></nav>

      <div>
        <div id="trailer" className="flex flex-col gap-4">
          <h5>טריילר</h5>
 <GreyBorderBottom className="w-full" />

          <div className="w-full mt-4 h-[200px] flex justify-center items-center relative">
            {!isPlaying && anime?.trailer?.url ? (
              <>
                {/* 🔹 בדיקה: אם אין תמונה ב-trailer, נשתמש ב-placeholder */}
                <img
                  src={
                    anime?.trailer?.images?.large_image_url ||
                    anime?.trailer?.images?.image_url ||
                    anime.images?.webp?.large_image_url ||
                    anime.images?.jpg?.large_image_url ||
                    anime.images?.webp?.image_url ||
                    anime.images?.jpg?.image_url ||
                    'https://placehold.co/320x180?text=No+Trailer'
                  }
                  alt={`${
                    anime?.title_hebrew || anime?.title_english || anime?.title
                  } Trailer Thumbnail`}
                  className="w-full h-full object-cover"
                />

                {/* 🔹 כפתור ניגון */}
                <button
                  className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 hover:bg-opacity-75 transition-all duration-300"
                  onClick={() => setIsPlaying(true)}
                  title="Play Trailer"
                >
                  <img
                    src={topAnimesImages.unSelectedTrailer}
                    alt="Play Button"
                    className="w-[80px] h-[80px] object-contain"
                  />
                </button>
              </>
            ) : anime?.trailer?.embed_url ? (
              <ReactPlayer
                url={anime.trailer.embed_url}
                playing
                controls
                width="100%"
                height="100%"
                config={{
                  youtube: {
                    playerVars: {
                      modestbranding: 1,
                      rel: 0,
                      showinfo: 0,
                    },
                  },
                }}
              />
            ) : (
              <div className="flex justify-center items-center w-full h-full bg-gray-900 text-white">
                אין טריילר זמין
              </div>
            )}
          </div>

          <div className="flex gap-8 text-center justify-center my-6">
            <div>
              <p className="text-muted text-sm">עונה</p>
              <span className="text-softText text-lg">
                {translatedSeason[anime.season] || anime.season || 'לא צויין'}
              </span>
            </div>
            <div>
              <p className="text-muted text-sm">זמני שידור</p>
              <span className="text-softText text-lg">
                {daysTranslation[anime.broadcast?.day] ||
                  anime.broadcast?.day ||
                  'לא צויין'}
                {anime.broadcast?.time ? `, ${anime.broadcast.time}` : ''}
              </span>
            </div>
            <div>
              <p className="text-muted text-sm">סטטוס</p>
              <span className="text-softText text-lg">
                {translatedStatus[anime.status] || anime.status || 'לא צויין'}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="my-4 ">
        <img
          className="w-full "
          src={postListNewImages.longLineDivider}
          alt="Divider"
        />
      </div>

      {/* תקציר */}
      <div className="flex justify-between items-center my-6">
        <p className="text-white text-lg">תקציר</p>
        <button onClick={() => toggleSynopsis(!openSynopsis)}>
          <img
            src={
              openSynopsis
                ? userProfileImages.arrowUp
                : userProfileImages.arrowDown
            }
            alt="Toggle Synopsis"
          />
        </button>
      </div>
      {openSynopsis && (
        <div className="text-softText flex flex-col gap-2">
          <p>{anime.synopsis_hebrew || anime.synopsis || 'אין תקציר זמין'}</p>
        </div>
      )}

      {/* רקע */}
      <div className="flex justify-between items-center my-6">
        <p className="text-white text-lg">רקע</p>
        <button onClick={() => toggleBackground(!openBackground)}>
          <img
            src={
              openBackground
                ? userProfileImages.arrowUp
                : userProfileImages.arrowDown
            }
            alt="Toggle Background"
          />
        </button>
      </div>
      {openBackground && (
        <div className="text-softText flex flex-col gap-2">
          <p>
            {anime.background_hebrew ||
              anime.background ||
              'אין מידע על רקע זמין'}
          </p>
        </div>
      )}

      <div>
        <div className="flex justify-between items-center my-6">
          <p className="text-white text-lg">שמות נוספים</p>
          <button onClick={() => toggleSection(!openSection)}>
            <img
              src={
                openSection
                  ? userProfileImages.arrowUp
                  : userProfileImages.arrowDown
              }
              alt="Toggle Bio"
            />
          </button>
        </div>
        {openSection && (
          <div className="text-softText flex flex-col gap-2">
            {anime.title_japanese && <p>יפנית: {anime.title_japanese}</p>}
            {anime.title_synonyms.length > 0 && (
              <p>שמות נוספים: {anime.title_synonyms.join(', ')}</p>
            )}
          </div>
        )}
      </div>

      <div className="flex flex-col gap-6">
        <div className="flex justify-between items-center my-6">
          <p className="text-white text-lg">מידע נוסף</p>
          <button onClick={() => toggleMoreInfo(!moreInfo)}>
            <img
              src={
                moreInfo
                  ? userProfileImages.arrowUp
                  : userProfileImages.arrowDown
              }
              alt="Toggle Bio"
            />
          </button>
        </div>

        {moreInfo && (
          <div className="flex flex-col gap-6">
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">סוג</h6>
              <span className="text-softText text-sm">{anime?.type}</span>
            </div>
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">פרקים</h6>
              <span className="text-softText text-sm">{anime?.episodes}</span>
            </div>
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">קטגוריה</h6>
              <span className="text-softText text-sm w-[80%] text-left">
                {anime?.genres?.length
                  ? mapAndTranslate(
                      anime.genres.map((g) => g.name),
                      translationMap
                    ).join(', ')
                  : 'לא צויין'}{' '}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">תת קטגוריה</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.themes?.length
                  ? mapAndTranslate(
                      anime.themes.map((t) => t.name),
                      translationMap
                    ).join(', ')
                  : 'לא צויין'}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">דמוגרפיה</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.demographics?.length
                  ? mapAndTranslate(
                      anime.demographics.map((d) => d.name),
                      translationMap
                    ).join(', ')
                  : 'לא צויין'}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">דקות</h6>
              <span className="text-softText text-sm">
                {extractMinutes(anime?.duration)}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">מפיקים</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.producers?.length
                  ? anime.producers.map((p) => p.name).join(', ')
                  : 'לא צויין'}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">זכויות</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.licensors?.length
                  ? anime.licensors.map((l) => l.name).join(', ')
                  : 'לא צויין'}
              </span>
            </div>
            <div className="flex justify-between items-center">
              <h6 className="text-muted text-sm">סטודיו</h6>
              <span className="text-softText text-sm w-[70%] text-left">
                {anime?.studios?.length
                  ? anime.studios.map((s) => s.name).join(', ')
                  : 'לא צויין'}
              </span>
            </div>
          </div>
        )}
      </div>

      <div className="mt-4 ">
        <img
          className="w-full "
          src={postListNewImages.longLineDivider}
          alt="Divider"
        />
      </div>
      <div id="share" className="flex justify-between my-4">
        <button
          onClick={async () => {
            await navigator.clipboard.writeText(window.location.href)
            toast.success('קישור הועתק !')
          }}
          className="text-muted text-md hover:underline"
        >
          העתק קישור
        </button>
        <div className="flex gap-4 items-center">
          <WhatsappShareButton url={window.location.href} title={anime.title}>

              <WhatsappIcon className="text-primary w-6 h-6" />

          </WhatsappShareButton>
          <TelegramShareButton url={window.location.href} title={anime.title}>
              <TelegramIcon className="text-primary w-6 h-6" />
          </TelegramShareButton>

          <button
            onClick={async () => {
              await navigator.clipboard.writeText(window.location.href)
              toast.success('קישור הועתק לשיתוף בטיקטוק!')
            }}
          >
              <TiktokIcon className="text-primary w-6 h-6" />
          </button>

          <button
            onClick={async () => {
              await navigator.clipboard.writeText(window.location.href)
              toast.success('קישור הועתק לשיתוף בדיסקורד!')
            }}
          >
              <DiscordIcon className="text-primary w-6 h-6" />
          </button>
        </div>
      </div>
      <div className="mb-4 ">
        <img
          className="w-full "
          src={postListNewImages.longLineDivider}
          alt="Divider"
        />
      </div>

      {/* ✅ הצגת אנימות דומות */}
      {(anime.relations && anime.relations.length > 0) ||
      (anime.similarAnime && anime.similarAnime.length > 0) ? (
        <div>
          <div className="flex flex-col gap-4">
            <div>
              <h5>אנימות דומות</h5>
              <GreyBorderBottom className="w-full" />
            </div>
          </div>

          <div className="flex mt-4 justify-between">
            <div className="w-[95%]">
              <Slider {...sliderSettings} ref={sliderRef}>
                {anime.relations && anime.relations.length > 0
                  ? anime.relations.flatMap((relation) =>
                      relation.entry.map((entry) => {
                        const animeData = relationsData[entry.mal_id] || {}
                        const imageSrc = getAnimeImage(animeData)

                        const title_hebrew = animeData?.title_hebrew || ''
                        const title = entry.name
                        const altTitle = `${title_hebrew} // ${title}`

                        return (
                          <div
                            key={entry.mal_id}
                            className="flex flex-col items-center px-2 transition-all duration-300"
                          >
                            {entry.type === 'anime' ? (
                              <Link
                                to={getAnimeDetailsUrl(entry)}
                                className="block w-full"
                              >
                                <img
                                  src={imageSrc}
                                  alt={altTitle}
                                  className="w-[130px] h-[180px] object-cover rounded transition-transform duration-300"
                                />
                              </Link>
                            ) : (
                              <img
                                src={imageSrc}
                                alt={altTitle}
                                className="w-[130px] h-[180px] object-cover rounded transition-transform duration-300 cursor-pointer"
                                onClick={() =>
                                  toast.error(
                                    'כרגע אין מידע זמין על מנגות באתר'
                                  )
                                }
                              />
                            )}

                            <div className="w-[130px] flex flex-col items-center text-center bg-secondaryBackground p-4">
                              <p
                                className="text-white rtl-truncate max-w-full"
                                title={altTitle}
                              >
                                <span>{title_hebrew}</span> //{' '}
                                <span>{title}</span>
                              </p>
                            </div>
                          </div>
                        )
                      })
                    )
                  : anime.similarAnime && anime.similarAnime.length > 0
                  ? anime.similarAnime.map((animeItem) => {
                      const title_hebrew = animeItem?.title_hebrew || ''
                      const title = animeItem.title_english || animeItem.title
                      const altTitle = `${title_hebrew} // ${title}`

                      return (
                        <div
                          key={animeItem.mal_id}
                          className="flex flex-col items-center px-2 transition-all duration-300"
                        >
                          <Link
                            to={getAnimeDetailsUrl(animeItem)}
                            className="block w-full"
                          >
                            <img
                              src={getAnimeImage(animeItem)}
                              alt={altTitle}
                              className="w-[130px] h-[180px] object-cover rounded transition-transform duration-300"
                            />
                          </Link>

                          <div className="w-full flex flex-col items-center text-center bg-secondaryBackground p-4">
                            <p
                              className="text-white rtl-truncate max-w-full"
                              title={altTitle}
                            >
                              <span>{title_hebrew}</span> //{' '}
                              <span>{title}</span>
                            </p>
                          </div>
                        </div>
                      )
                    })
                  : null}
              </Slider>
            </div>
          </div>
        </div>
      ) : (
        <p className="text-white text-center w-full">אין נתונים זמינים</p>
      )}
    </div>
  )
}
